<template>
  <div id="getPolicyDetails">
    <v-header title="保单详情"></v-header>
    <!-- <div class="detailsCon"> -->
    <el-row type="flex" justify="center" class="gp_details">
      <el-col :span="24" class="colCon">
        <el-tabs v-model="activeName" @tab-click="handleClick" class="outBox" :stretch="true">
          <el-tab-pane label="基本信息" name="1">
            <el-row type="flex" justify="center">
              <el-card class="cardBox">
                <el-row type="flex" justify="center" class="cardBoxShow">
                  <el-col :span="11">
                    <span class="cardBoxTitle">产品名称</span><span class="cardBoxWord">{{ details.chineseName }}</span>
                  </el-col>
                  <el-col :span="7">
                    <span class="cardBoxTitle">投保日</span><span class="cardBoxWord">{{ details.hpropdte }}</span>
                  </el-col>
                  <el-col :span="6">
                    <span class="cardBoxTitle">保单生效日</span><span class="cardBoxWord">{{ details.ccdate }}</span>
                    <!-- <span class="cardBoxTitle">保单失效日</span><span class="cardBoxWord">{{details.invdate}}</span> -->
                  </el-col>
                  <el-col :span="11">
                    <span class="cardBoxTitle">保单号</span><span class="cardBoxWord">{{ details.chdrnum }}</span>
                  </el-col>
                  <el-col :span="7">
                    <span class="cardBoxTitle">受理日</span><span class="cardBoxWord">{{ details.invdate }}</span>
                  </el-col>
                  <el-col :span="6">
                    <span class="cardBoxTitle">保单失效日</span><span class="cardBoxWord">{{ details.invdate }}</span>
                    <!-- <span class="cardBoxTitle">宽限期截至日</span><span class="cardBoxWord">{{details.invdate}}</span> -->
                  </el-col>
                  <el-col :span="11">
                    <span class="cardBoxTitle">保单状态</span><span class="cardBoxWord">{{ details.statName }}</span>
                  </el-col>
                  <el-col :span="7">
                    <span class="cardBoxTitle">首次签发日</span><span class="cardBoxWord">{{ details.hoissdte }}</span>
                  </el-col>
                  <el-col :span="6">
                    <span class="cardBoxTitle">宽限期截至日</span><span class="cardBoxWord">{{ details.genddate }}</span>
                    <!-- <span class="cardBoxTitle">失效期截至日</span><span class="cardBoxWord">{{details.invenddate}}</span> -->
                  </el-col>
                  <el-col :span="11">
                    <span class="cardBoxTitle">保费状态</span><span class="cardBoxWord">{{ details.pStatName }}</span>
                  </el-col>
                  <el-col :span="7">
                    <span class="cardBoxTitle">客户签收日</span><span class="cardBoxWord">{{ details.zackdte }}</span>
                  </el-col>
                  <el-col :span="6">
                    <span class="cardBoxTitle">失效期截至日</span><span class="cardBoxWord">{{ details.invenddate }}</span>
                    <!-- <span class="cardBoxTitle">缴费止期</span><span class="cardBoxWord">{{details.ptdate}}</span> -->
                  </el-col>
                  <el-col :span="11">
                    <span class="cardBoxTitle">总保费</span><span class="cardBoxWord">{{ details.premium }}</span>
                    <!-- <span class="cardBoxTitle">保单签发日</span><span class="cardBoxWord">{{details.hoissdte}}</span> -->
                  </el-col>
                  <el-col :span="7">
                    <span class="cardBoxTitle">保单签发日</span><span class="cardBoxWord">{{ details.hoissdte }}</span>
                    <!-- <span class="cardBoxTitle">当前服务人员</span><span class="cardBoxWord">{{details.addAgentName}}</span> -->
                  </el-col>
                  <el-col :span="6">
                    <span class="cardBoxTitle">缴费止期</span><span class="cardBoxWord">{{ details.ptdate }}</span>
                  </el-col>
                  <el-col :span="11">
                    <span class="cardBoxTitle">总保额</span><span class="cardBoxWord">{{ details.validSumins }}</span>
                  </el-col>
                  <el-col :span="7">
                    <span class="cardBoxTitle">核保决定日</span><span class="cardBoxWord">{{ details.huwdcdte }}</span>
                    <!-- <span class="cardBoxTitle">EI</span><span class="cardBoxWord">{{details.ei}}</span> -->
                  </el-col>
                  <el-col :span="6">
                    <span class="cardBoxTitle">FYC</span><span class="cardBoxWord">{{ details.fyc }}</span>
                  </el-col>

                  <el-col :span="11">
                    <span class="cardBoxTitle">当前服务人员</span><span class="cardBoxWord">{{ details.addAgentName }}</span>
                  </el-col>
                  <el-col :span="7">
                    <span class="cardBoxTitle">下次缴费日</span><span class="cardBoxWord">{{ details.ptdate }}</span>
                  </el-col>
                  <el-col :span="6">
                    <span class="cardBoxTitle">EI</span><span class="cardBoxWord">{{ details.ei }}</span>
                  </el-col>

                  <el-col :span="11">
                    <span class="cardBoxTitle">姓名</span><span class="cardBoxWord">{{ details.agntName }}({{ details.agntNum }})</span>
                  </el-col>
                </el-row>
              </el-card>
            </el-row>
            <el-row type="flex" justify="center" style="margin-top:40px">
              <el-col :span="24">
                <el-card class="cardBox xzinfo">
                  <div class="tableTop" @click="showPlanteds">
                    <label class="tableTopTitle">险种信息</label>
                    <label class="tableTopRight" v-show="showPlanted">收起 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                    <label class="tableTopRight" v-show="!showPlanted">展开 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                  </div>
                  <div v-show="showPlanted">
                    <template>
                      <el-table :data="tableData" style="width: 100%">
                        <el-table-column align="center" label="产品名称" width="320">
                          <template slot-scope="scope">
                            <div class="baseImg">
                              <span v-if="scope.row.rider != '00'"
                                ><img style="width:1.2rem;height:1.2rem;vertical-align: unset;" src="../../../static/image/policy/fu.png"
                              /></span>
                              <span v-else><img style="width:1.2rem;height:1.2rem; vertical-align: unset;" src="../../../static/image/policy/zhu.png"/></span>
                              {{ scope.row.chineseName }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="保费">
                          <template slot-scope="scope">
                            <span>{{ scope.row.premium }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="保额">
                          <template slot-scope="scope">
                            <span>{{ scope.row.sumins }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="保障期间">
                          <template slot-scope="scope">
                            <span>{{ scope.row.riskTerm }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="缴费期间">
                          <template slot-scope="scope">
                            <span>{{ scope.row.premiumTerm }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="状态">
                          <template slot-scope="scope">
                            <span>{{ scope.row.statName }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="风险起始日">
                          <template slot-scope="scope">
                            <span>{{ changeTime(scope.row.crrcd) }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="风险终止日">
                          <template slot-scope="scope">
                            <span>{{ changeTime(scope.row.rcesdte) }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="保费终止日">
                          <template slot-scope="scope">
                            <span>{{ changeTime(scope.row.pcesdte) }}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center" style="margin-top:40px">
              <el-col :span="24">
                <el-card class="cardBox">
                  <div class="tableTop" @click="getInsuredPersion">
                    <label class="tableTopTitle">投保人信息</label>
                    <label v-show="InsuredPersionShow" class="tableTopRight"
                      >收起 <img style="width:16px" src="../../../static/image/policy/triangle.png" />
                    </label>
                    <label v-show="!InsuredPersionShow" class="tableTopRight"
                      >展开 <img style="width:16px" src="../../../static/image/policy/triangle.png" />
                    </label>
                  </div>
                  <div v-show="InsuredPersionShow">
                    <template>
                      <el-table v-loading="loading1" :data="InsuredPersionData" style="width: 100%">
                        <el-table-column align="center" label="客户号">
                          <template slot-scope="scope">
                            <img v-if="scope.ridires === '00'" class="" />
                            <img v-else class="" />
                            <span style="margin-left: 10px">{{ scope.row.data.clntnum }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="投保人">
                          <template slot-scope="scope">
                            <span>{{ scope.row.data.fullName }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="称谓">
                          <template slot-scope="scope">
                            <span>{{ scope.row.data.salut }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="出生日期">
                          <template slot-scope="scope">
                            <span>{{ changeTime(scope.row.data.cltdob) }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="证件号" width="240">
                          <template slot-scope="scope">
                            <span>{{ scope.row.data.secuityNo }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="联系方式1" width="150">
                          <template slot-scope="scope">
                            <span>{{ scope.row.data.cltPhone01 }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="联系方式2" width="150">
                          <template slot-scope="scope">
                            <span>{{ scope.row.data.cltPhone02 }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="联系地址" width="340">
                          <template slot-scope="scope">
                            <span>{{ scope.row.data.fullAddress }}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </div>
                  <el-row type="flex" justify="center" style="margin-top:40px" v-show="InsuredPersionShow">
                    <el-col :span="24">
                      <el-card class="cardBox">
                        <div class="tableTop" @click="getPersionHistory">
                          <label class="tableTopTitle">投保人历史信息</label>
                          <label v-show="InsuredPersionHistoryShow" class="tableTopRight"
                            >收起 <img style="width:16px" src="../../../static/image/policy/triangle.png" />
                          </label>
                          <label v-show="!InsuredPersionHistoryShow" class="tableTopRight"
                            >展开 <img style="width:16px" src="../../../static/image/policy/triangle.png" />
                          </label>
                        </div>
                        <div v-show="InsuredPersionHistoryShow">
                          <template>
                            <el-table v-loading="loading2" :data="InsuredPersionDataHistory" style="width: 100%">
                              <el-table-column align="center" label="客户号">
                                <template slot-scope="scope">
                                  <span style="margin-left: 10px">{{ scope.row.data.clntnum }}</span>
                                </template>
                              </el-table-column>
                              <el-table-column align="center" label="投保人">
                                <template slot-scope="scope">
                                  <span size="medium">{{ scope.row.data.fullName }}</span>
                                </template>
                              </el-table-column>
                              <el-table-column align="center" label="称谓">
                                <template slot-scope="scope">
                                  <span>{{ scope.row.data.salut }}</span>
                                </template>
                              </el-table-column>
                              <el-table-column align="center" label="出生日期">
                                <template slot-scope="scope">
                                  <span>{{ changeTime(scope.row.data.cltdob) }}</span>
                                </template>
                              </el-table-column>
                              <el-table-column align="center" label="证件号" width="240">
                                <template slot-scope="scope">
                                  <span>{{ scope.row.data.secuityNo }}</span>
                                </template>
                              </el-table-column>
                              <el-table-column align="center" label="联系方式1" width="150">
                                <template slot-scope="scope">
                                  <span>{{ scope.row.data.cltPhone01 }}</span>
                                </template>
                              </el-table-column>
                              <el-table-column align="center" label="联系方式2" width="150">
                                <template slot-scope="scope">
                                  <span>{{ scope.row.data.cltPhone02 }}</span>
                                </template>
                              </el-table-column>
                              <el-table-column align="center" label="联系地址" width="340">
                                <template slot-scope="scope">
                                  <span>{{ scope.row.data.fullAddress }}</span>
                                </template>
                              </el-table-column>
                            </el-table>
                          </template>
                        </div>
                      </el-card>
                    </el-col>
                  </el-row>
                </el-card>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center" style="margin-top:40px">
              <el-col :span="24">
                <el-card class="cardBox">
                  <div class="tableTop" @click="insuredPersion">
                    <label class="tableTopTitle">被保人信息</label>
                    <label v-show="applicant" class="tableTopRight">收起 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                    <label v-show="!applicant" class="tableTopRight">展开 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                  </div>
                  <div v-show="applicant">
                    <template>
                      <el-table v-loading="loading3" :data="InsuredPersions" style="width: 100%">
                        <el-table-column align="center" label="客户号">
                          <template slot-scope="scope">
                            <img v-if="scope.ridires === '00'" class="" />
                            <img v-else class="" />
                            <span style="margin-left: 10px">{{ scope.row.clntnum }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="被保人">
                          <template slot-scope="scope">
                            <span>{{ scope.row.fullName }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="称谓">
                          <template slot-scope="scope">
                            <span>{{ scope.row.salut }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="出生日期">
                          <template slot-scope="scope">
                            <span>{{ changeTime(scope.row.cltdob) }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="证件号" width="240">
                          <template slot-scope="scope">
                            <span>{{ scope.row.secuityNo }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="联系方式1" width="150">
                          <template slot-scope="scope">
                            <span>{{ scope.row.cltPhone01 }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="联系方式2" width="150">
                          <template slot-scope="scope">
                            <span>{{ scope.row.cltPhone02 }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="联系地址" width="340">
                          <template slot-scope="scope">
                            <span>{{ scope.row.fullAddress }}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <template v-for="(item, index) in liveClntnums">
              <el-row type="flex" justify="center" style="margin-top:40px">
                <el-col :span="24">
                  <el-card class="cardBox">
                    <Beneficiary :cowncoy="cowncoy" :type="1" :clntnum="item"></Beneficiary>
                  </el-card>
                </el-col>
              </el-row>
            </template>
            <template v-for="(item, index) in deathClntnums">
              <el-row type="flex" justify="center" style="margin-top:40px">
                <el-col :span="24">
                  <el-card class="cardBox">
                    <Beneficiary :cowncoy="cowncoy" :type="2" :clntnum="item"></Beneficiary>
                  </el-card>
                </el-col>
              </el-row>
            </template>
            <el-row type="flex" justify="center" style="margin-top:40px">
              <el-col :span="24">
                <el-card class="cardBox">
                  <div class="tableTop" @click="getAccountInfo">
                    <label class="tableTopTitle">账户信息</label>
                    <label v-show="AccountInfoShow" class="tableTopRight"
                      >收起 <img style="width:16px" src="../../../static/image/policy/triangle.png" />
                    </label>
                    <label v-show="!AccountInfoShow" class="tableTopRight"
                      >展开 <img style="width:16px" src="../../../static/image/policy/triangle.png" />
                    </label>
                  </div>
                  <div v-show="AccountInfoShow">
                    <template>
                      <el-table v-loading="loading5" :data="AccountInfo" style="width: 100%">
                        <el-table-column align="center" label="所有者姓名" width="180">
                          <template slot-scope="scope">
                            <img v-if="scope.ridires === '00'" class="" />
                            <img v-else class="" />
                            <span style="margin-left: 10px">{{ scope.row.fullName }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="所有者证件号" width="200">
                          <template slot-scope="scope">
                            <span>{{ scope.row.securityNo }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="银行代码">
                          <template slot-scope="scope">
                            <span>{{ scope.row.bankKey }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="账户名称">
                          <template slot-scope="scope">
                            <span>{{ scope.row.bankAccKey }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="首期/续期标志">
                          <template slot-scope="scope">
                            <span>{{ scope.row.type }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="有效/失效">
                          <template slot-scope="scope">
                            <span>{{ scope.row.mandStat }}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="保单营销资料" name="2" class="pane2">
            <el-row type="flex" justify="center" class="pane2-boxshow">
              <el-card class="cardBox">
                <el-row>
                  <el-col :span="8">
                    <span class="cardBoxTitle">业务代码</span><span class="cardBoxWord">{{ AgentInfo.agetnum }}</span>
                  </el-col>
                  <el-col :span="8">
                    <span class="cardBoxTitle">渠道</span><span class="cardBoxWord">{{ AgentInfo.addChnlcod }}</span>
                  </el-col>
                  <el-col :span="8">
                    <span class="cardBoxTitle">姓名</span><span class="cardBoxWord">{{ AgentInfo.fullName }}</span>
                  </el-col>
                  <el-col :span="8">
                    <span class="cardBoxTitle">出生日期</span><span class="cardBoxWord">{{ AgentInfo.cltdob }}</span>
                  </el-col>
                  <el-col :span="8">
                    <span class="cardBoxTitle">称谓</span><span class="cardBoxWord">{{ AgentInfo.salut }}</span>
                  </el-col>
                  <el-col :span="8">
                    <span class="cardBoxTitle">客户代码</span><span class="cardBoxWord">{{ AgentInfo.clntnum }}</span>
                  </el-col>
                  <el-col :span="8">
                    <span class="cardBoxTitle">入司日期</span><span class="cardBoxWord">{{ AgentInfo.startDate }}</span>
                  </el-col>
                  <el-col :span="8">
                    <span class="cardBoxTitle">离职日期</span><span class="cardBoxWord">{{ AgentInfo.dtetrm }}</span>
                  </el-col>
                  <el-col :span="8">
                    <span class="cardBoxTitle">证件号</span><span class="cardBoxWord">{{ AgentInfo.secuityNo }}</span>
                  </el-col>
                  <el-col :span="8">
                    <span class="cardBoxTitle">电话1</span><span class="cardBoxWord">{{ AgentInfo.cltPhone01 }}</span>
                  </el-col>
                  <el-col :span="8">
                    <span class="cardBoxTitle">电话2</span><span class="cardBoxWord">{{ AgentInfo.cltPhone02 }}</span>
                  </el-col>
                  <el-col :span="24">
                    <span class="cardBoxTitle">通讯地址</span><span class="cardBoxWord">{{ AgentInfo.fullAddress }}</span>
                  </el-col>
                </el-row>
              </el-card>
            </el-row>
            <el-row type="flex" justify="center" style="margin-top:40px">
              <el-col :span="24">
                <el-card class="cardBox">
                  <div class="tableTop" @click="teamShowNow">
                    <label class="tableTopTitle">团队信息</label>
                    <label class="tableTopRight" v-show="teamShow">收起 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                    <label class="tableTopRight" v-show="!teamShow">展开 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                  </div>
                  <div v-show="teamShow">
                    <template>
                      <el-table v-loading="loading6" :data="TeamInfo" style="width: 100%">
                        <el-table-column align="center" label="组经理姓名" prop="zFullName">
                          <!-- <template slot-scope="scope">
                                                    <span style="margin-left: 10px">{{ scope.row.zFullName}}</span>
                                                </template> -->
                        </el-table-column>
                        <el-table-column align="center" label="组经理代码" width="180" prop="zAgntnum">
                          <!-- <template slot-scope="scope">
                                                    <span>{{scope.row.zAgntnum}}</span>
                                                </template> -->
                        </el-table-column>
                        <el-table-column align="center" label="部经理姓名" prop="bFullName">
                          <!-- <template slot-scope="scope">
                                                        <span >{{scope.row.bFullName}}</span>
                                                    </template> -->
                        </el-table-column>
                        <el-table-column align="center" label="部经理代码" prop="bAgntnum">
                          <!-- <template slot-scope="scope">
                                                        <span >{{scope.row.bAgntnum}}</span>
                                                    </template> -->
                        </el-table-column>
                        <el-table-column align="center" label="区经理姓名" prop="qFullName">
                          <!-- <template slot-scope="scope">
                                                        <span>{{scope.row.qFullName}}</span>
                                                    </template> -->
                        </el-table-column>
                        <el-table-column align="center" label="区经理代码" prop="qAgntnum">
                          <!-- <template slot-scope="scope">
                                                        <span>{{scope.row.qAgntnum}}</span>
                                                    </template> -->
                        </el-table-column>
                      </el-table>
                    </template>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center" style="margin-top:40px">
              <el-col :span="24">
                <el-card class="cardBox">
                  <div class="tableTop" @click="AgentHistoryShowNow">
                    <label class="tableTopTitle">历史信息</label>
                    <label class="tableTopRight" v-show="AgentHistoryShow"
                      >收起 <img style="width:16px" src="../../../static/image/policy/triangle.png" />
                    </label>
                    <label class="tableTopRight" v-show="!AgentHistoryShow"
                      >展开 <img style="width:16px" src="../../../static/image/policy/triangle.png" />
                    </label>
                  </div>
                  <div v-show="AgentHistoryShow">
                    <template>
                      <el-table v-loading="loading7" :data="AgentHistoryInfo[0]" style="width: 100%">
                        <el-table-column align="center" label="业务代码">
                          <template slot-scope="scope">
                            <span style="margin-left: 10px">{{ scope.row.agetnum }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="姓名">
                          <template slot-scope="scope">
                            <span>{{ scope.row.fullName }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="离职日期">
                          <template slot-scope="scope">
                            <span>{{ scope.row.dtetrm }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="状态">
                          <template slot-scope="scope">
                            <span v-if="scope.row.status === 1">离职</span>
                            <span v-if="scope.row.status === 0">在职</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="开始服务日">
                          <template slot-scope="scope">
                            <span>{{ scope.row.currentFrom }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="结束服务日">
                          <template slot-scope="scope">
                            <span>{{ scope.row.currentTo }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="联系方式1" width="150">
                          <template slot-scope="scope">
                            <span>{{ scope.row.cltPhone01 }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="联系方式2" width="150">
                          <template slot-scope="scope">
                            <span>{{ scope.row.cltPhone02 }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="联系地址" width="340">
                          <template slot-scope="scope">
                            <span>{{ scope.row.fullAddress }}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="新保记录" name="3">
            <el-row type="flex" justify="center" style="margin-top:40px">
              <el-col :span="24">
                <el-card class="cardBox">
                  <div class="tableTop" @click="getOptionsShowNow">
                    <label class="tableTopTitle">新单操作历史记录</label>
                    <label class="tableTopRight" v-show="OptionsShwo">收起 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                    <label class="tableTopRight" v-show="!OptionsShwo">展开 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                  </div>
                  <div v-show="OptionsShwo">
                    <template>
                      <el-table v-loading="loading8" :data="OptionsInfo[0]" style="width: 100%">
                        <el-table-column align="center" label="操作名称" prop="f_TypeName">
                          <!-- <template slot-scope="scope">
                                                    <span style="margin-left: 10px">{{ scope.row.f_TypeName}}</span>
                                                </template> -->
                        </el-table-column>
                        <el-table-column align="center" label="时间" prop="f_Time">
                          <template slot-scope="scope">
                            <span>{{ changeTime(scope.row.f_Time) }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="描述" prop="f_DisplayName">
                          <!-- <template slot-scope="scope">
                                                        <span >{{scope.row.f_DisplayName}}</span>
                                                    </template> -->
                        </el-table-column>
                        <el-table-column align="center" label="原因" prop="f_Reason">
                          <!-- <template slot-scope="scope">
                                                        <span >{{scope.row.f_Reason}}</span>
                                                    </template> -->
                        </el-table-column>
                        <el-table-column align="center" label="备注" prop="f_Description">
                          <!-- <template slot-scope="scope">
                                                        <span>{{scope.row.f_Description}}</span>
                                                    </template> -->
                        </el-table-column>
                      </el-table>
                    </template>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center" style="margin-top:40px">
              <el-col :span="24">
                <el-card class="cardBox">
                  <div class="tableTop" @click="NoteShowNow">
                    <label class="tableTopTitle">新单照会信息</label>
                    <label class="tableTopRight" v-show="NoteShow">收起 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                    <label class="tableTopRight" v-show="!NoteShow">展开 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                  </div>
                  <div v-show="NoteShow">
                    <template>
                      <el-table v-loading="loading9" :data="NoteInfo[0]" style="width: 100%">
                        <el-table-column align="center" label="照会编号">
                          <template slot-scope="scope">
                            <span style="margin-left: 10px">{{ scope.row.f_Code }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="照会名称">
                          <template slot-scope="scope">
                            <span>{{ scope.row.f_TypeName }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="状态">
                          <template slot-scope="scope">
                            <span>{{ scope.row.f_Type }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="创建时间">
                          <template slot-scope="scope">
                            <span>{{ changeTime(scope.row.f_InsertTime) }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="发送时间">
                          <template slot-scope="scope">
                            <span>{{ changeTime(scope.row.f_SendTime) }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="回复时间">
                          <template slot-scope="scope">
                            <span>{{ changeTime(scope.row.f_ReplyTime) }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="最近催办时间">
                          <template slot-scope="scope">
                            <span>{{ changeTime(scope.row.f_LastReminderTime) }}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="保单扣款记录" name="4">
            <el-row type="flex" justify="center" style="margin-top:40px">
              <el-col :span="24">
                <el-card class="cardBox">
                  <div class="tableTop" @click="RecvFirstShowNow">
                    <label class="tableTopTitle">首期扣款记录</label>
                    <label class="tableTopRight" v-show="RecvFirstShow">收起 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                    <label class="tableTopRight" v-show="!RecvFirstShow"
                      >展开 <img style="width:16px" src="../../../static/image/policy/triangle.png" />
                    </label>
                  </div>
                  <div v-show="RecvFirstShow">
                    <template>
                      <el-table v-loading="loading10" :data="RecvFirstInfo[0]" style="width: 100%">
                        <el-table-column align="center" label="银行">
                          <template slot-scope="scope">
                            <span style="margin-left: 10px">{{ scope.row.bankDesc }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="账户">
                          <template slot-scope="scope">
                            <span>{{ scope.row.bankAccKey }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="金额">
                          <template slot-scope="scope">
                            <span>{{ scope.row.dBAmt }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="应扣日期">
                          <template slot-scope="scope">
                            <span>{{ scope.row.zDEXTDTE }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="扣款日期">
                          <template slot-scope="scope">
                            <span>{{ scope.row.zDRTNDTE }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="原因">
                          <template slot-scope="scope">
                            <span>{{ scope.row.reasonName }}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center" style="margin-top:40px">
              <el-col :span="24">
                <el-card class="cardBox">
                  <div class="tableTop" @click="RecvShowNow">
                    <label class="tableTopTitle">续期扣款记录</label>
                    <label class="tableTopRight" v-show="RecvShow">收起 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                    <label class="tableTopRight" v-show="!RecvShow">展开 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                  </div>
                  <div v-if="RecvShow">
                    <template>
                      <el-table v-loading="loading11" :data="RecvInFo" style="width: 100%">
                        <el-table-column align="center" label="银行">
                          <template slot-scope="scope">
                            <span style="margin-left: 10px">{{ scope.row.bankDesc }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="账户">
                          <template slot-scope="scope">
                            <span>{{ scope.row.bankAccKey }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="金额">
                          <template slot-scope="scope">
                            <span>{{ scope.row.dBAmt }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="应扣日期">
                          <template slot-scope="scope">
                            <span>{{ scope.row.zDEXTDTE }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="扣款日期">
                          <template slot-scope="scope">
                            <span>{{ scope.row.zDRTNDTE }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="原因">
                          <template slot-scope="scope">
                            <span>{{ scope.row.reasonName }}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="保单现价红利" name="5">
            <el-row type="flex" justify="center" style="margin-top:40px">
              <el-col :span="24">
                <el-card class="cardBox">
                  <div class="tableTop" @click="BonusShowNow">
                    <label class="tableTopTitle">红利现价</label>
                    <label class="tableTopRight" v-show="BonusShow">收起 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                    <label class="tableTopRight" v-show="!BonusShow">展开 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                  </div>
                  <div v-if="BonusShow">
                    <template>
                      <el-table v-loading="loading12" :data="BonusInfo" style="width: 100%">
                        <el-table-column align="center" label="首次红利日">
                          <template slot-scope="scope">
                            <span style="margin-left: 10px">{{ scope.row.first_Divd_Date }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="上次分红日">
                          <template slot-scope="scope">
                            <span>{{ scope.row.last_Divd_Date }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="上一计息日">
                          <template slot-scope="scope">
                            <span>{{ scope.row.last_Int_Date }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="前一融资日">
                          <template slot-scope="scope">
                            <span>{{ scope.row.last_Cap_Date }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="下一融资日">
                          <template slot-scope="scope">
                            <span>{{ scope.row.next_Cap_Date }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="合计分配">
                          <template slot-scope="scope">
                            <span>{{ scope.row.bal_At_Last_Divd }}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center" style="margin-top:40px">
              <el-col :span="24">
                <el-card class="cardBox">
                  <div class="tableTop" @click="SnapshotShowNow">
                    <label class="tableTopTitle">现金价值</label>
                    <label class="tableTopRight" v-show="SnapshotShow">收起 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                    <label class="tableTopRight" v-show="!SnapshotShow">展开 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                  </div>
                  <div v-show="SnapshotShow">
                    <template>
                      <el-table v-loading="loading13" :data="SnapshotInfo" style="width: 100%">
                        <el-table-column align="center" label="保单号">
                          <template slot-scope="scope">
                            <span style="margin-left: 10px">{{ scope.row.chdrNum }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="现价日">
                          <template slot-scope="scope">
                            <span>{{ scope.row.daTime }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="险种代码">
                          <template slot-scope="scope">
                            <span>{{ scope.row.crTable }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="险种现价">
                          <template slot-scope="scope">
                            <span>{{ scope.row.surrval }}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center" style="margin-top:40px">
              <el-col :span="24">
                <el-card class="cardBox">
                  <div class="tableTop" @click="EXPYShowNow">
                    <label class="tableTopTitle">生存金</label>
                    <label class="tableTopRight" v-show="EXPYShow">收起 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                    <label class="tableTopRight" v-show="!EXPYShow">展开 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                  </div>
                  <div v-show="EXPYShow">
                    <template>
                      <el-table v-loading="loading14" :data="EXPYInfo" style="width: 100%">
                        <el-table-column align="center" label="保单号">
                          <template slot-scope="scope">
                            <span style="margin-left: 10px">{{ scope.row.chdrNum }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="保单生效日">
                          <template slot-scope="scope">
                            <span>{{ scope.row.rCD }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="生存金给付日">
                          <template slot-scope="scope">
                            <span>{{ scope.row.last_DIVD_Date }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="生存金金额">
                          <template slot-scope="scope">
                            <span>{{ scope.row.origamt }}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="回访/照会" name="6">
            <el-row type="flex" justify="center" style="margin-top:40px">
              <el-col :span="24">
                <el-card class="cardBox">
                  <div class="tableTop" @click="callBackShowNow">
                    <label class="tableTopTitle">回访列表</label>
                    <label class="tableTopRight" v-show="callBackShow">收起 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                    <label class="tableTopRight" v-show="!callBackShow">展开 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                  </div>
                  <div v-show="callBackShow">
                    <template>
                      <el-table v-loading="loading15" :data="callBackInfo[0]" style="width: 100%">
                        <el-table-column align="center" label="回访时间" width="180">
                          <template slot-scope="scope">
                            <span style="margin-left: 10px">{{ scope.row.callBackDate }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="回访电话" width="150">
                          <template slot-scope="scope">
                            <span>{{ scope.row.callBackTel }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="回访类型">
                          <template slot-scope="scope">
                            <span>{{ scope.row.callBackType }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="回访人员">
                          <template slot-scope="scope">
                            <span>{{ scope.row.callBackGHID }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="回访次数">
                          <template slot-scope="scope">
                            <span>{{ scope.row.callBackTime }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="回访结果" width="150">
                          <template slot-scope="scope">
                            <span>{{ scope.row.callBackResult }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="回访状态">
                          <template slot-scope="scope">
                            <span>{{ scope.row.callBackStatus }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="呼叫编号" width="300">
                          <template slot-scope="scope">
                            <span>{{ scope.row.callID }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="话术结果">
                          <template slot-scope="scope">
                            <el-popover trigger="hover" placement="left">
                              <p v-show="scope.row.prors != ''" style="text-align:center;">{{ scope.row.prors }}</p>
                              <p v-show="scope.row.prors == ''" style="text-align:center;">-</p>
                              <div slot="reference" class="name-wrapper">
                                <span class="pointer">查看</span>
                              </div>
                            </el-popover>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center" style="margin-top:40px">
              <el-col :span="24">
                <el-card class="cardBox">
                  <div class="tableTop" @click="NotesShowNow">
                    <label class="tableTopTitle">照会列表</label>
                    <label class="tableTopRight" v-show="NotesShow">收起 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                    <label class="tableTopRight" v-show="!NotesShow">展开 <img style="width:16px" src="../../../static/image/policy/triangle.png" /> </label>
                  </div>
                  <div v-show="NotesShow">
                    <template>
                      <el-table v-loading="loading16" :data="NotesInfo[0]" style="width: 100%">
                        <el-table-column align="center" label="发送时间" width="180">
                          <template slot-scope="scope">
                            <span style="margin-left: 10px">{{ scope.row.sDate }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="照会编号" width="220">
                          <template slot-scope="scope">
                            <span>{{ scope.row.noteID }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="照会类型">
                          <template slot-scope="scope">
                            <span>{{ scope.row.noteType }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="分公司编号">
                          <template slot-scope="scope">
                            <span>{{ scope.row.cHDYCOYID }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="保单号">
                          <template slot-scope="scope">
                            <span>{{ scope.row.cHDRNum }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="发送坐席">
                          <template slot-scope="scope">
                            <span>{{ scope.row.gHID }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="照会文件名称" width="300">
                          <template slot-scope="scope">
                            <span>{{ scope.row.noteName }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" label="照会次数">
                          <template slot-scope="scope">
                            <span>{{ scope.row.noteTime }}</span>
                          </template>
                        </el-table-column>
                        <!-- <el-table-column
                                                    align="center"
                                                    label="详情">
                                                    <template slot-scope="scope">
                                                        <el-popover trigger="hover" placement="left">
                                                            <p v-show="scope.row.prors!=''">{{scope.row.prors}}</p>
                                                            <p v-show="scope.row.prors==''" style="text-align:center;">-</p>
                                                            <div slot="reference" class="name-wrapper">
                                                                <span class="pointer">查看</span>
                                                            </div>
                                                    </el-popover>
                                                    </template>
                                                </el-table-column> -->
                      </el-table>
                    </template>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <!-- </div> -->
  </div>
</template>

<script>
import api from '../../modules/api'
import urls from '../../modules/url'
import vHeader from '@/layout/Header1.vue'
import Beneficiary from './components/Beneficiary'
export default {
  name: 'getPolicyDetails',
  components: { vHeader, Beneficiary },
  data() {
    return {
      loading1: false,
      loading2: false,
      loading3: false,
      loading4: false,
      loading5: false,
      loading6: false,
      loading7: false,
      loading8: false,
      loading9: false,
      loading10: false,
      loading11: false,
      loading12: false,
      loading13: false,
      loading14: false,
      loading15: false,
      loading16: false,
      showPlanted: false,
      activeName: '1',
      details: {},
      tableData: [],
      InsuredPersionData: [],
      InsuredPersionDataHistory: [],
      InsuredPersions: [], // 被保人
      beneficiaryPersion: [], // 受益人
      AgentInfo: {}, // 营销信息
      TeamInfo: [], // 团队信息
      AgentHistoryInfo: [], // 团队历史
      OptionsInfo: [], // 新保历史
      NoteInfo: [], // 新单记录
      RecvFirstInfo: [], // 首次扣款
      RecvInFo: [], // 续期
      BonusInfo: [], // 红利现价
      SnapshotInfo: [], // 现金
      EXPYInfo: [], // 生存金
      callBackInfo: [], // 回访
      NotesInfo: [], // 照会
      routerDTO: {
        CHDRCOY: '',
        BRANCH: '',
        CHDRNUM: '',
        AGNTNUM: '',
        VALIDFLAG: '',
        LIFE: '01',
        COVERAGE: '',
        AGNTCOY: ''
      },
      cowncoy: '',
      cownnum: '',
      InsuredPersionShow: false,
      InsuredPersionHistoryShow: false,
      applicant: false,
      beneficiaryShow: false,
      AccountInfoShow: false,
      teamShow: false,
      AgentHistoryShow: false,
      OptionsShwo: false,
      NoteShow: false,
      RecvFirstShow: false,
      RecvShow: false,
      BonusShow: false,
      EXPYShow: false,
      SnapshotShow: false,
      callBackShow: false,
      NotesShow: false,
      insuredClntnum: '', // 被保人
      liveClntnums: [], // 生存受益人客户号
      deathClntnums: [], // 死亡受益人客户号
      AccountInfo: '' // 账户信息
    }
  },
  methods: {
    handleClick(tab, event) {
      let that = this
      if (that.activeName === '2') {
        that.getAgentInfo()
      } else if (that.activeName === '3') {
      } else if (that.activeName === '4') {
      } else if (that.activeName === '5') {
      } else if (that.activeName === '6') {
      }
    },
    showPlanteds() {
      if (this.showPlanted === true) {
        this.showPlanted = false
        console.log('111111')
      } else {
        this.showPlanted = true
        console.log('222222')
      }
    },
    changeTime(data) {
      let time = data.slice(0, 4) + '-' + data.slice(4, 6) + '-' + data.slice(6, 8)
      if (!data) {
        time = ''
      }
      if (data == '0') {
        time = data
      }
      return time
    },
    getPolicyAbout() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let options = {
        CHDRCOY: this.routerDTO.CHDRCOY,
        CHDRNUM: this.routerDTO.CHDRNUM
      }
      console.log('options: ' + options)
      let msg = { queryTerms: JSON.stringify(options) }
      api.getPolicyAbout(msg, res => {
        loading.close()
        if (res.result.isSuccess === true) {
          let response = res.data.data
          this.details = res.data.data
          console.log(this.details)
          this.details.hpropdte = this.changeTime(response.hpropdte)
          this.details.invdate = this.changeTime(response.invdate)
          this.details.hissdte = this.changeTime(response.hissdte)
          this.details.hoissdte = this.changeTime(response.hoissdte)
          this.details.zackdte = this.changeTime(response.zackdte)
          this.details.invenddate = this.changeTime(response.invenddate)
          this.details.ptdate = this.changeTime(response.ptdate)
          this.details.ccdate = this.changeTime(response.ccdate)
          this.details.hprrcvdt = this.changeTime(response.hprrcvdt)
          this.details.huwdcdte = this.changeTime(response.huwdcdte)
          this.details.genddate = this.changeTime(response.genddate)
          let responseRisks = res.data.data.risks
          this.tableData = []
          responseRisks.forEach(resData => {
            // resData.riskTerm = this.changeTime(resData.riskTerm)
            this.tableData.push(resData)
          })
          // this.tableData = res.data.data.risks
          this.routerDTO.COVERAGE = res.data.data.risks[0].coverage
          this.insuredClntnum = res.data.data.insuredClntnum // 被保人
          this.liveClntnums = res.data.data.liveClntnums // 生存受益人
          this.deathClntnums = res.data.data.deathClntnums // 死亡受益人
          this.cowncoy = res.data.data.cowncoy
          this.cownnum = res.data.data.cownnum
          console.log(this.details, 'details')
          console.log(res, '获取信息')
        }
      })
    },
    getInsuredPersion() {
      this.loading1 = true
      let holderOptions = {
        CLNTCOY: this.cowncoy,
        CLNTNUM: this.cownnum,
        type: '1'
      }
      let message = { queryTerms: JSON.stringify(holderOptions) }
      api.getPersionInfo(message, response => {
        this.loading1 = false
        this.InsuredPersionData = []
        if (response.data) {
          this.InsuredPersionData.push(response.data)
          this.InsuredPersionData.cltdob = response.data.cltdob
        }
        console.log(this.InsuredPersionData, '投保人数据')
        console.log(response.data, '人')
      })
      if (this.InsuredPersionShow === true) {
        this.InsuredPersionShow = false
      } else {
        this.InsuredPersionShow = true
      }
    },
    // 历史
    getPersionHistory() {
      this.loading2 = true
      this.InsuredPersionDataHistory.length = 0
      let options = {
        CHDRCOY: this.cowncoy,
        CHDRNUM: this.cownnum,
        type: '1'
      }
      let message = { queryTerms: JSON.stringify(options) }
      api.getPersionHistory(message, res => {
        this.loading2 = false
        this.InsuredPersionDataHistory = []
        if (res.data.data) {
          this.InsuredPersionDataHistory = res.data.data
          //   this.InsuredPersionDataHistory.cltdob = res.data.data.cltdob
        }
        console.log(res, '历史')
      })
      if (this.InsuredPersionHistoryShow === true) {
        this.InsuredPersionHistoryShow = false
      } else {
        this.InsuredPersionHistoryShow = true
      }
    },
    insuredPersion() {
      this.loading3 = true
      let options = {
        CLNTCOY: this.cowncoy,
        CLNTNUM: this.insuredClntnum, // this.$route.query.chdrnumId,
        type: '1'
      }
      let mes = { queryTerms: JSON.stringify(options) }
      api.getPersionInfo(mes, res => {
        this.loading3 = false
        this.InsuredPersions = []
        if (res.data.data) {
          this.InsuredPersions.push(res.data.data)
          this.InsuredPersions.cltdob = res.data.cltdob
        }
        console.log(this.InsuredPersions, '被保人')
      })
      if (this.applicant === true) {
        this.applicant = false
      } else {
        this.applicant = true
      }
    },

    getAccountInfo() {
      this.loading5 = true
      let that = this
      let options = {
        CHDRCOY: that.routerDTO.CHDRCOY,
        BRANCH: that.routerDTO.BRANCH,
        CHDRNUM: that.routerDTO.CHDRNUM
      }
      let mes = { queryTerms: JSON.stringify(options) }
      api.getAccountInfo(mes, res => {
        that.loading5 = false
        that.AccountInfo = []
        if (res.data.data) {
          that.AccountInfo = res.data.data
        }
        console.log('账户信息', this.AccountInfo)
        console.log(res, '账户信息')
      })
      if (this.AccountInfoShow === true) {
        this.AccountInfoShow = false
      } else {
        this.AccountInfoShow = true
      }
    },
    getAgentInfo() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let that = this
      let submitInfo = {
        AGNTCOY: that.routerDTO.AGNTCOY,
        AGNTNUM: that.routerDTO.AGNTNUM
      }
      let msg = { queryTerms: JSON.stringify(submitInfo) }
      api.post(urls.getAgentInfo, msg, res => {
        console.log(res, '营销')
        loading.close()
        if (res.result.isSuccess) {
          let response = res.data.data
          that.AgentInfo = res.data.data
          that.AgentInfo.cltdob = this.changeTime(response.cltdob)
          that.AgentInfo.startDate = this.changeTime(response.startDate)
          that.AgentInfo.dtetrm = this.changeTime(response.dtetrm)
        } else {
          alert('查询失败')
        }
      })
    },
    teamShowNow() {
      let that = this
      if (that.teamShow === true) {
        that.teamShow = false
      } else {
        that.TeamInfo.length = 0
        that.getTean()
        that.teamShow = true
      }
    },
    AgentHistoryShowNow() {
      let that = this
      if (that.AgentHistoryShow === true) {
        that.AgentHistoryShow = false
      } else {
        that.AgentHistoryInfo.length = 0
        that.getAgentHistory()
        that.AgentHistoryShow = true
      }
    },
    getTean() {
      this.loading6 = true
      let that = this
      let options = {
        AGNTCOY: that.routerDTO.AGNTCOY,
        AGNTNUM: that.routerDTO.AGNTNUM
      }
      let mes = { queryTerms: JSON.stringify(options) }
      api.post(urls.getTeam, mes, res => {
        that.loading6 = false
        that.TeamInfo = []
        if (res.data.data) {
          that.TeamInfo.push(res.data.data)
        }
        console.log(res, '团队信息')
      })
    },
    getAgentHistory() {
      this.loading7 = true
      let that = this
      let options = {
        CHDRCOY: that.routerDTO.CHDRCOY,
        BRANCH: that.routerDTO.BRANCH,
        CHDRNUM: that.routerDTO.CHDRNUM
      }
      let msg = { queryTerms: JSON.stringify(options) }
      api.post(urls.getAgentHistory, msg, res => {
        that.loading7 = false
        that.AgentHistoryInfo = []
        if (res.data.data) {
          that.AgentHistoryInfo.push(res.data.data)
        }
        console.log(res, '团队历史信息')
      })
    },
    getOptionsShowNow() {
      if (this.OptionsShwo !== false) {
        this.OptionsShwo = false
      } else {
        this.OptionsInfo.length = 0
        this.getOptions()
        this.OptionsShwo = true
      }
    },
    getOptions() {
      this.loading8 = true
      let that = this
      let options = {
        CHDRCOY: that.routerDTO.CHDRCOY,
        BRANCH: that.routerDTO.BRANCH,
        CHDRNUM: that.routerDTO.CHDRNUM
      }
      let msg = { queryTerms: JSON.stringify(options) }
      that.OptionsInfo = []
      api.post(urls.getOptions, msg, res => {
        that.loading8 = false
        if (res.data.data) {
          that.OptionsInfo.push(res.data.data)
          console.log('optionsInfo', that.OptionsInfo)
          console.log(res, '新单历史')
        }
      })
    },
    NoteShowNow() {
      let that = this
      if (that.NoteShow !== false) {
        that.NoteShow = false
      } else {
        that.getNoteInfo()
        that.NoteShow = true
      }
    },
    getNoteInfo() {
      this.loading9 = true
      let that = this
      let options = {
        CHDRCOY: that.routerDTO.CHDRCOY,
        BRANCH: that.routerDTO.BRANCH,
        CHDRNUM: that.routerDTO.CHDRNUM
      }
      let msg = { queryTerms: JSON.stringify(options) }
      api.post(urls.getNoteInfo, msg, res => {
        that.loading9 = false
        that.NoteInfo = []
        if (res.data.data) {
          that.NoteInfo.push(res.data.data)
          // that.NoteInfo = res.data.data
        }

        console.log(res, '新单历史1')
      })
    },
    RecvFirstShowNow() {
      if (this.RecvFirstShow !== false) {
        this.RecvFirstShow = false
      } else {
        this.getRecvFirst()
        this.RecvFirstShow = true
      }
    },
    getRecvFirst() {
      this.loading10 = true
      let that = this
      let options = {
        CHDRCOY: that.routerDTO.CHDRCOY,
        BRANCH: that.routerDTO.BRANCH,
        CHDRNUM: that.routerDTO.CHDRNUM
      }
      let msg = { queryTerms: JSON.stringify(options) }
      api.post(urls.getRecvFirst, msg, res => {
        that.loading10 = false
        that.RecvFirstInfo = []
        console.log(res, '首次扣款')
        if (res.data.data) {
          that.RecvFirstInfo.push(res.data.data)
        }
      })
    },
    RecvShowNow() {
      if (this.RecvShow !== false) {
        this.RecvShow = false
      } else {
        this.getRecv()
        this.RecvShow = true
      }
    },
    getRecv() {
      this.loading11 = true
      let that = this
      let options = {
        CHDRCOY: that.routerDTO.CHDRCOY,
        BRANCH: that.routerDTO.BRANCH,
        CHDRNUM: that.routerDTO.CHDRNUM
      }
      let msg = { queryTerms: JSON.stringify(options) }
      api.post(urls.getRecv, msg, res => {
        that.loading11 = false
        that.RecvInFo = []

        if (res.data.data) {
          that.RecvInFo = res.data.data
        }
        console.log(that.RecvInFo, '首次续期log')
      })
    },
    BonusShowNow() {
      if (this.BonusShow !== false) {
        this.BonusShow = false
      } else {
        this.getPolicyBonus()
        this.BonusShow = true
      }
    },
    getPolicyBonus() {
      this.loading12 = true
      let that = this
      let submitInfo = {
        CHDRCOY: that.routerDTO.CHDRCOY,
        BRANCH: that.routerDTO.BRANCH,
        CHDRNUM: that.routerDTO.CHDRNUM,
        LIFE: that.routerDTO.LIFE,
        COVERAGE: that.routerDTO.COVERAGE,
        VALIDFLAG: that.routerDTO.VALIDFLAG
      }
      let msg = { queryTerms: JSON.stringify(submitInfo) }
      api.post(urls.getPolicyBonus, msg, res => {
        that.loading12 = false
        that.BonusInfo = []
        if (res.data.data) {
          that.BonusInfo = res.data.data
        }
        console.log(res, '红利现价')
      })
    },
    SnapshotShowNow() {
      if (this.SnapshotShow !== false) {
        this.SnapshotShow = false
      } else {
        this.SnapshotShow = true
        this.getSnapshot()
      }
    },
    getSnapshot() {
      this.loading13 = true
      let that = this
      let submitInfo = {
        CHDRCOY: that.routerDTO.CHDRCOY,
        BRANCH: that.routerDTO.BRANCH,
        CHDRNUM: that.routerDTO.CHDRNUM
      }
      let msg = { queryTerms: JSON.stringify(submitInfo) }
      api.post(urls.getSnapshot, msg, res => {
        that.loading13 = false
        that.SnapshotInfo = []
        if (res.data.data) {
          that.SnapshotInfo = res.data.data
        }
      })
    },
    EXPYShowNow() {
      if (this.EXPYShow !== false) {
        this.EXPYShow = false
      } else {
        this.getEXPY()
        this.EXPYShow = true
      }
    },
    getEXPY() {
      this.loading14 = true
      let that = this
      let submitInfo = {
        CHDRCOY: that.routerDTO.CHDRCOY,
        BRANCH: that.routerDTO.BRANCH,
        CHDRNUM: that.routerDTO.CHDRNUM
      }
      let msg = { queryTerms: JSON.stringify(submitInfo) }
      api.post(urls.getEXPY, msg, res => {
        that.loading14 = false
        that.EXPYInfo = []
        if (res.data.data) {
          that.EXPYInfo = res.data.data
        }
        console.log(res, '生存金')
      })
    },
    callBackShowNow() {
      if (this.callBackShow !== false) {
        this.callBackShow = false
      } else {
        this.getCallBack()
        this.callBackShow = true
      }
    },
    getCallBack() {
      this.loading15 = true
      let that = this
      let submitInfo = {
        CHDRCOY: that.routerDTO.CHDRCOY,
        BRANCH: that.routerDTO.BRANCH,
        CHDRNUM: that.routerDTO.CHDRNUM
      }
      let msg = { queryTerms: JSON.stringify(submitInfo) }

      // 调用接口保存告知数据
      api.post(urls.getCallBack, msg, function(res) {
        that.loading15 = false
        that.callBackInfo = []
        console.log(res, '回访')
        if (res.result.isSuccess === true) {
          that.callBackInfo.push(res.data.data.getCallBackListResponseVo)
        } else {
          that.$toast(res.result.error)
        }
      })
    },
    NotesShowNow() {
      if (this.NotesShow !== false) {
        this.NotesShow = false
      } else {
        this.getCallBackNote()
        this.NotesShow = true
      }
    },
    getCallBackNote() {
      this.loading16 = true
      let that = this
      let submitInfo = {
        CHDRCOY: that.routerDTO.CHDRCOY,
        BRANCH: that.routerDTO.BRANCH,
        CHDRNUM: that.routerDTO.CHDRNUM
      }
      let msg = { queryTerms: JSON.stringify(submitInfo) }

      // 调用接口保存告知数据
      api.post(urls.getCallBack, msg, function(res) {
        that.loading16 = false
        that.NotesInfo = []
        console.log(res, '照会')
        if (res.result.isSuccess === true) {
          that.NotesInfo.push(res.data.data.getCallBackNotesResponseVo)
        } else {
          that.$toast(res.result.error)
        }
      })
    },
    clearAlldata() {
      this.activeName = '1'
      this.showPlanted = false
      this.InsuredPersionShow = false
      this.InsuredPersionHistoryShow = false
      this.applicant = false
      this.beneficiaryShow = false
      this.AccountInfoShow = false
      this.teamShow = false
      this.AgentHistoryShow = false
      this.OptionsShwo = false
      this.NoteShow = false
      this.RecvFirstShow = false
      this.RecvShow = false
      this.BonusShow = false
      this.SnapshotShow = false
      this.EXPYShow = false
      this.callBackShow = false
      this.NotesShow = false
    }
  },
  activated() {
    this.clearAlldata()
    this.routerDTO = JSON.parse(sessionStorage.getItem('routerDTO'))
    this.getPolicyAbout()
    var container = document.querySelector('#main_div')
    container.scrollTop = 0
  }
}
</script>
<style lang="scss" scoped>
#getPolicyDetails /deep/ .el-tabs__item {
  font-size: 16px;
}
#getPolicyDetails /deep/ .el-table th > .cell {
  color: #c5a86e;
}
#getPolicyDetails /deep/ .el-card.is-always-shadow {
  box-shadow: none;
  -webkit-box-shadow: none;
}
#getPolicyDetails /deep/ .el-table__row:last-child td {
  border-bottom: 0;
}

#getPolicyDetails {
  height: 100%;
  .outBox {
    background: #fff;
    padding: 20px 30px;
    box-sizing: border-box;
    width: 100%;
    .cardBox {
      width: 100%;
      box-sizing: border-box;
    }
    .cardBoxShow {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      line-height: 34px;
    }
    .cardBoxTitle {
      display: inline-block;
      width: 130px;
      color: #919191;
      font-size: 16px;
      line-height: 24px;
    }
    .cardBoxWord {
      display: inline-block;
      color: #111111;
      font-size: 16px;
      line-height: 24px;
    }
    .tableTop {
      // cursor: pointer;
      width: calc(100% + 40px);
      height: 40px;
      background: #f7f7f7;
      margin-top: -20px;
      margin-left: -20px;
      margin-right: -20px;
      cursor: pointer;
      .tableTopTitle {
        padding-left: 20px;
        font-size: 15px;
        line-height: 40px;
        color: #111111;
        font-weight: 500;
      }
      .tableTopRight {
        cursor: pointer;
        padding-right: 40px;
        float: right;
        font-size: 16px;
        line-height: 40px;
        img {
          width: 16px;
        }
      }
    }
  }
}
.pane2 {
  .pane2-boxshow {
    line-height: 34px;
  }
}
.el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: transparent;
}
.gp_details {
  width: 96%;
  margin: 0 auto;
  height: calc(100% - 80px);
  overflow: auto;
  box-sizing: border-box;
  padding-top: 50px;
}
.gp_details::-webkit-scrollbar {
  width: 0px;
}

.baseImg span {
  vertical-align: -webkit-baseline-middle;
}
//   险种信息产品列左对齐样式
.xzinfo /deep/ .el-table__row td:nth-child(1) {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/policy/getPolicyDetails.vue